import React from "react";
import _post from "../Functions/Post"
import Barcode from "react-jsbarcode"

export default class PrintPackages extends React.Component {

    constructor() {
        super();
        this.state = {
            transaction: false,
            username: ""
        }
    }

    async componentDidMount() {
        const transaction = JSON.parse(localStorage.getItem("Transaction"));
        const user = JSON.parse(localStorage.getItem("Username"));
        this.setState({transaction: transaction, username: user});
    }

    render() {
        return (
            <div>
                {(this.state.transaction) ?
                    <div className="row m-3">
                        <div className="col">
                            <p>Source: <b>{this.state.transaction.source_location_id[1]}</b></p>
                        </div>
                        <div className="col">
                            <p>Destination: <b>{this.state.transaction.dest_location_id[1]}</b></p>
                        </div>
                    </div>
                    : null
                }
                {this.props.packages.map((item, index) => {
                    if (item.isFound) {
                        return (
                            <Barcode ref={el => (this.componentRef = el)} value={item.name} key={index}/>
                        )
                    }
                })
                }
            </div>
        )
    }
}